const corporateHotel = {
  // page.tsx
  'corporateHotel.page.lastUpdated': '最終更新: 2026年6月13日',
  'corporateHotel.page.backToTop': 'ページトップへ戻る',

  // JSON-LD
  'corporateHotel.jsonld.serviceName': 'ホテル・旅館向け接遇研修｜バトラーサービスの型を整える',
  'corporateHotel.jsonld.orgName': '一般社団法人全日本執事協会',
  'corporateHotel.jsonld.serviceType': 'ホテル向け接遇研修',
  'corporateHotel.jsonld.areaServed': '日本',
  'corporateHotel.jsonld.description': 'ホテル・旅館向けのバトラーサービス研修。開業前集中対応、1日330,000円税込〜、全国出張。執事教育の手法で客室接遇の型を短期間に整えます。',
  'corporateHotel.jsonld.breadcrumb1': 'ホーム',
  'corporateHotel.jsonld.breadcrumb2': '法人研修',
  'corporateHotel.jsonld.breadcrumb3': 'ホテル・旅館向け',

  // HeroSection
  'corporateHotel.hero.homeLink': 'ホーム',
  'corporateHotel.hero.corporateLink': '法人研修',
  'corporateHotel.hero.currentPage': 'ホテル・旅館向け',
  'corporateHotel.hero.title': 'ホテル・旅館向け 法人研修',
  'corporateHotel.hero.titleEn': 'FOR HOTELS & RYOKAN',
  'corporateHotel.hero.lead': 'ホテル・旅館向け研修は、バトラーサービスと客室接遇の型を日本の執事学校による執事教育の手法で短期間に整えるプログラムです。',
  'corporateHotel.hero.ctaBtn': 'この業種で相談する',
  'corporateHotel.hero.imgAlt': 'スイートルームでウェルカムティーを提供する日本人バトラー',
  'corporateHotel.hero.badge1': 'スイート・ラウンジ運営の型を確立',
  'corporateHotel.hero.badge2': '出張型で貴館の現場に合わせた訓練',
  'corporateHotel.hero.badge3': '執事養成課程と同一の講師陣',

  // PainPoints
  'corporateHotel.pain.label': 'CHALLENGES',
  'corporateHotel.pain.title': 'こんな課題をお持ちではありませんか',
  'corporateHotel.pain.subtitleEn': 'Common Challenges',
  'corporateHotel.pain.lead': 'ホテル・旅館特有の接遇課題に、執事教育のメソッドでお応えします。',
  'corporateHotel.pain.item1': '開業・改装に向けてバトラー／クラブラウンジ運営の型が必要だが、社内に指導できる人材がいない',
  'corporateHotel.pain.item2': '海外VIP・インバウンド富裕層の期待値が上がっており、従来の接遇では満足されなくなっている',
  'corporateHotel.pain.item3': '接遇品質がスタッフごとにばらつき、ゲストアンケートの評価にも差が出ている',
  'corporateHotel.pain.item4': 'OJT頼みでサービスが言語化・標準化されておらず、人が替わると品質が維持できない',

  // WhyButlerWorks
  'corporateHotel.why.label': 'WHY BUTLER TRAINING',
  'corporateHotel.why.title': '執事教育がホテルに効く理由',
  'corporateHotel.why.subtitleEn': 'Why Butler Training Works',
  'corporateHotel.why.lead': '執事教育はバトラーサービスの原型であり、ホテル接遇が求める「型の再現性」とまさに一致します。',
  'corporateHotel.why.item1.title': 'バトラーサービスの原型',
  'corporateHotel.why.item1.desc': '執事教育は「一人のゲストに仕え切る」技術の体系であり、バトラーサービスの原型そのものです。立ち居振る舞いから先回りの準備まで、バトラーに求められるすべての基盤を一貫したメソッドで習得できます。',
  'corporateHotel.why.item2.title': '座学2割・実技8割の訓練',
  'corporateHotel.why.item2.desc': '客室・ラウンジを想定した動作訓練を中心に、実際に体を動かして型を覚えます。頭で理解するだけでなく、身体が自然に動くレベルまで反復することで、研修翌日から現場で再現できる品質を目指します。',
  'corporateHotel.why.item3.title': '「型」の言語化と再現性',
  'corporateHotel.why.item3.desc': '執事教育の強みは、勘や経験則に頼らず「なぜその所作なのか」を言語化して伝えられることです。研修後も社内で教育・点検できる基準としてお使いいただけるよう、型を明文化してお渡しします。',

  // RecommendedPrograms
  'corporateHotel.programs.label': 'RECOMMENDED PROGRAMMES',
  'corporateHotel.programs.title': 'おすすめプラン',
  'corporateHotel.programs.subtitleEn': 'Recommended for Hotels',
  'corporateHotel.programs.lead': '貴館の状況や目標に合わせて、最適なプランをお選びいただけます。',
  'corporateHotel.programs.recommended': 'おすすめ',
  'corporateHotel.programs.currency': '円（税込）',
  'corporateHotel.programs.ctaBtn': 'このプランで相談する',
  'corporateHotel.programs.detailNote': 'モジュールの詳細は',
  'corporateHotel.programs.detailLink': '法人研修総合ページ',
  'corporateHotel.programs.detailSuffix': 'をご覧ください。',
  'corporateHotel.programs.p1.title': '半日プラン例',
  'corporateHotel.programs.p1.duration': '3時間',
  'corporateHotel.programs.p1.modules': 'M1（立ち居振る舞い）＋ M3（ティー＆テーブル実技）',
  'corporateHotel.programs.p1.desc': 'バトラーサービスの基本所作とティーサービスの実技に集中する短期プランです。開業後のブラッシュアップ研修や、まずは試行的に導入したい場合に適しています。',
  'corporateHotel.programs.p2.title': '1日プラン例',
  'corporateHotel.programs.p2.duration': '6時間',
  'corporateHotel.programs.p2.modules': 'M1 ＋ M2（VIP対応の原則）＋ M3 ＋ M4（想定外対応ロールプレイング）',
  'corporateHotel.programs.p2.desc': '立ち居振る舞いからVIP対応、ロールプレイングまで、バトラーサービスの基盤を1日で網羅する推奨プランです。',
  'corporateHotel.programs.p3.title': '開業前集中（3日間）',
  'corporateHotel.programs.p3.duration': '18時間（3日間）',
  'corporateHotel.programs.p3.modules': '全6モジュール ＋ 貴館の動線に合わせた通し稽古',
  'corporateHotel.programs.p3.desc': '開業準備に特化した集中プログラムです。全モジュールを修めた上で、実際の客室・ラウンジの動線を使った総合演習を行い、開業初日から一貫したバトラーサービスを提供できる体制を整えます。',

  // ScenarioTraining
  'corporateHotel.scenario.note': '※シナリオは貴館の客室・施設条件に合わせて差し替え可能です。',
  'corporateHotel.scenario.label': 'SCENARIO TRAINING',
  'corporateHotel.scenario.title': 'シナリオ訓練',
  'corporateHotel.scenario.subtitleEn': 'Hotel Scenarios',
  'corporateHotel.scenario.lead': 'ホテル・旅館の現場を想定した3つのシナリオで実技を深めます。',
  'corporateHotel.scenario.s1.title': 'スイートでのウェルカムティー',
  'corporateHotel.scenario.s1.desc': 'チェックイン時の客室案内から、トレイの持ち方・置き方、ティーカップの向き、注ぎの所作、退出までの一連の流れを客室想定のセッティングで反復練習します。ゲストの荷物やコートの扱い方も含め、スイートサービスに求められる「静かで無駄のない動き」を体得します。',
  'corporateHotel.scenario.s2.title': 'インルームダイニング',
  'corporateHotel.scenario.s2.desc': 'ルームサービスワゴンの押し方・止め方、卓上セッティングの手順、料理の説明と配膳、ゲストが食事を終えるタイミングを見極めた下膳まで、インルームダイニングの全工程を実技で確認します。細かな所作の積み重ねがゲストの満足度を左右することを実感できる演習です。',
  'corporateHotel.scenario.s3.title': 'VIPのお出迎え',
  'corporateHotel.scenario.s3.desc': '車寄せでの第一声から、エレベーターまでのエスコート、客室到着後のご案内まで、VIPゲストを迎える一連の動線をロールプレイングします。声がけのタイミング、距離感、荷物の預かり方など、ゲストに「このホテルなら安心だ」と思わせる所作を訓練します。',

  // TargetRoles
  'corporateHotel.roles.label': 'TARGET ROLES',
  'corporateHotel.roles.title': '対象職種',
  'corporateHotel.roles.subtitleEn': 'Who Should Attend',
  'corporateHotel.roles.lead': '以下の職種の方々に特にお勧めします。',
  'corporateHotel.roles.capacity': '推奨12名まで',
  'corporateHotel.roles.capacityNote': '超過する場合は2班制や複数回開催などの形式をご提案します。現場（客室・ラウンジ）での出張実施に対応いたします。',
  'corporateHotel.roles.r1': 'バトラー',
  'corporateHotel.roles.r2': 'コンシェルジュ',
  'corporateHotel.roles.r3': 'クラブラウンジ係',
  'corporateHotel.roles.r4': '料飲サービス',
  'corporateHotel.roles.r5': 'フロント',
  'corporateHotel.roles.r6': '客室係',
  'corporateHotel.roles.r7': '新入社員研修担当',

  // PricingTable
  'corporateHotel.pricing.label': 'PRICING',
  'corporateHotel.pricing.title': '料金プラン',
  'corporateHotel.pricing.subtitleEn': 'Transparent Pricing',
  'corporateHotel.pricing.lead': 'すべて税込価格での明確な料金体系です。貴館のご予算と目標に合わせてお選びください。',
  'corporateHotel.pricing.header.plan': 'プラン',
  'corporateHotel.pricing.header.duration': '時間',
  'corporateHotel.pricing.header.price': '料金（税込）',
  'corporateHotel.pricing.header.note': '内容',
  'corporateHotel.pricing.recommended': '標準',
  'corporateHotel.pricing.currency': '円',
  'corporateHotel.pricing.plan1.name': '半日プラン',
  'corporateHotel.pricing.plan1.duration': '3時間',
  'corporateHotel.pricing.plan1.note': '2モジュール選択',
  'corporateHotel.pricing.plan2.name': '1日プラン',
  'corporateHotel.pricing.plan2.duration': '6時間',
  'corporateHotel.pricing.plan2.note': '4モジュール選択',
  'corporateHotel.pricing.plan3.name': '2日間パッケージ',
  'corporateHotel.pricing.plan3.duration': '12時間（2日間）',
  'corporateHotel.pricing.plan3.note': '全6モジュール受講可',
  'corporateHotel.pricing.plan4.name': '開業前集中',
  'corporateHotel.pricing.plan4.duration': '18時間（3日間）',
  'corporateHotel.pricing.plan4.note': '開業準備に特化した集中設計',
  'corporateHotel.pricing.plan5.name': '継続プログラム',
  'corporateHotel.pricing.plan5.duration': '月1回半日×6ヶ月',
  'corporateHotel.pricing.plan5.note': '定着と改善を繰り返す長期設計',
  'corporateHotel.pricing.conditions.title': '共通条件',
  'corporateHotel.pricing.conditions.dispatch': '出張時の交通費・宿泊費は実費別途',
  'corporateHotel.pricing.conditions.capacity': '推奨12名まで（超過は2班制等をご提案）',
  'corporateHotel.pricing.conditions.payment': 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  'corporateHotel.pricing.conditions.cancel': 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
  'corporateHotel.pricing.allMenuNote': '継続プログラム・覆面サービス診断などの全メニューは',
  'corporateHotel.pricing.allMenuLink': '法人研修総合ページ',
  'corporateHotel.pricing.allMenuSuffix': 'をご覧ください。',
  'corporateHotel.pricing.ctaBtn': '研修について問い合わせる',

  // FlowSteps
  'corporateHotel.flow.label': 'FLOW',
  'corporateHotel.flow.title': 'ご利用の流れ',
  'corporateHotel.flow.subtitleEn': 'From Enquiry to Results',
  'corporateHotel.flow.lead': 'お問い合わせから実施後レポートまで、5つのステップで着実に進めます。',
  'corporateHotel.flow.step1.title': 'お問い合わせ',
  'corporateHotel.flow.step1.desc': 'フォームまたはお電話・メールにてご連絡ください。',
  'corporateHotel.flow.step2.title': 'ヒアリング',
  'corporateHotel.flow.step2.desc': '対象人数・課題・希望時期などをオンラインまたはお電話で伺います。開業前の場合は開業予定日もお聞かせください。',
  'corporateHotel.flow.step3.title': 'プログラム提案・お見積り',
  'corporateHotel.flow.step3.desc': 'ヒアリング内容をもとに、貴館に最適な研修プログラムとお見積りをご提案します。',
  'corporateHotel.flow.step4.title': '実施',
  'corporateHotel.flow.step4.desc': '出張または来校にて研修を実施します。出張型では実際の客室やラウンジで訓練します。',
  'corporateHotel.flow.step5.title': '実施後レポート',
  'corporateHotel.flow.step5.desc': '研修の総括と改善提案をまとめたレポートをお届けします。',

  // ContactForm
  'corporateHotel.contact.label': 'CONTACT',
  'corporateHotel.contact.title': 'お問い合わせ',
  'corporateHotel.contact.subtitleEn': 'Enquiry Form',
  'corporateHotel.contact.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。',
  'corporateHotel.contact.phoneLead': 'フォームのほか、お電話',
  'corporateHotel.contact.phoneOr': 'またはメール',
  'corporateHotel.contact.phoneAlso': 'でも承ります。',
  'corporateHotel.contact.hours': '受付時間: 平日 10:00〜17:00',
  'corporateHotel.contact.company': '貴館名・会社名',
  'corporateHotel.contact.company.placeholder': '例: ○○ホテル',
  'corporateHotel.contact.department': '部署・役職',
  'corporateHotel.contact.department.placeholder': '例: 人事部 研修担当',
  'corporateHotel.contact.name': 'ご担当者名',
  'corporateHotel.contact.name.placeholder': '例: 執事 太郎',
  'corporateHotel.contact.name.required': '必須',
  'corporateHotel.contact.name.error': 'ご担当者名は必須です',
  'corporateHotel.contact.email': 'メールアドレス',
  'corporateHotel.contact.email.placeholder': '例: taro@example.com',
  'corporateHotel.contact.email.required': '必須',
  'corporateHotel.contact.email.error': 'メールアドレスは必須です',
  'corporateHotel.contact.email.invalid': '有効なメールアドレスを入力してください',
  'corporateHotel.contact.phone': '電話番号',
  'corporateHotel.contact.phone.placeholder': '例: 090-1234-5678',
  'corporateHotel.contact.phone.required': '必須',
  'corporateHotel.contact.phone.error': '電話番号は必須です',
  'corporateHotel.contact.facilityType': '施設種別',
  'corporateHotel.contact.facilityType.required': '必須',
  'corporateHotel.contact.facilityType.error': '施設種別をお選びください',
  'corporateHotel.contact.format': '希望形式',
  'corporateHotel.contact.participants': '想定人数',
  'corporateHotel.contact.participants.placeholder': '例: 10名',
  'corporateHotel.contact.timeline': '検討時期',
  'corporateHotel.contact.timeline.placeholder': '例: 来月、開業3ヶ月前、未定',
  'corporateHotel.contact.message': 'ご相談内容（任意）',
  'corporateHotel.contact.message.placeholder': '研修の目的やご要望、ご不明な点など、自由にご記入ください。',
  'corporateHotel.contact.message.error': '500文字以内で入力してください',
  'corporateHotel.contact.submit.error': '送信中にエラーが発生しました。お手数ですが再度お試しいただくか、お電話にてお問い合わせください。',
  'corporateHotel.contact.submit': 'この内容で送信する',
  'corporateHotel.contact.submitting': '送信中...',
  'corporateHotel.contact.facilityType.select': '選択してください',
  'corporateHotel.contact.facilityType.cityHotel': 'シティホテル',
  'corporateHotel.contact.facilityType.resort': 'リゾート',
  'corporateHotel.contact.facilityType.ryokan': '旅館',
  'corporateHotel.contact.facilityType.preOpening': '開業準備中',
  'corporateHotel.contact.format.select': '選択してください',
  'corporateHotel.contact.format.dispatch': '出張',
  'corporateHotel.contact.format.onsite': '来校',
  'corporateHotel.contact.format.undecided': '未定',

  // FAQSection
  'corporateHotel.faq.label': 'FAQ',
  'corporateHotel.faq.title': 'よくあるご質問',
  'corporateHotel.faq.subtitleEn': 'Frequently Asked Questions',
  'corporateHotel.faq.otherNote': 'その他のご質問はフォームよりお寄せください',
  'corporateHotel.faq.q1': '執事の資格が取れる研修ですか？',
  'corporateHotel.faq.a1': 'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  'corporateHotel.faq.q2': '開業前の集中研修はできますか？',
  'corporateHotel.faq.a2': 'はい。開業前集中（3日間）プランをご用意しています。開業日程に合わせ、複数週への分割実施も可能です。',
  'corporateHotel.faq.q3': '実際の客室やラウンジで実施できますか？',
  'corporateHotel.faq.a3': 'はい、出張型で貴館の現場での実施に対応します。実際の動線で訓練することで、研修翌日からの再現性が高まります。',
  'corporateHotel.faq.q4': '外国語での研修は可能ですか？',
  'corporateHotel.faq.a4': '研修は日本語で実施します。海外ゲスト対応で使う英語の接遇表現を扱いたい場合は、ヒアリング時にご相談ください。',

  // CTASection
  'corporateHotel.cta.label': 'GET STARTED',
  'corporateHotel.cta.title': 'まずはお気軽にご相談ください',
  'corporateHotel.cta.lead': '貴館の課題をお聞かせいただければ、最適な研修プランを無料でご提案いたします。',
  'corporateHotel.cta.lead2': '開業日から逆算した研修計画のご相談も承ります。まずは日程の目安だけでもお聞かせください。',
  'corporateHotel.cta.inquiryBtn': 'この業種で相談する',
  'corporateHotel.cta.coursesBtn': '個人向けコースを見る',

  // RelatedPages
  'corporateHotel.related.label': 'OTHER INDUSTRIES',
  'corporateHotel.related.title': '他の業種別研修',
  'corporateHotel.related.subtitleEn': 'Other Industry Programmes',
  'corporateHotel.related.viewDetail': '詳しく見る',
  'corporateHotel.related.backToCorpBtn': '法人研修総合ページへ戻る',
  'corporateHotel.related.coursesBtn': '個人向けコース（執事養成課程）を見る',
  'corporateHotel.related.r1.title': '高級レジデンス',
  'corporateHotel.related.r1.desc': 'コンシェルジュ・フロントの接遇品質を統一',
  'corporateHotel.related.r2.title': '金融・プライベートバンク',
  'corporateHotel.related.r2.desc': '富裕層営業の信頼を所作から築く',
  'corporateHotel.related.r3.title': '百貨店外商・高級小売',
  'corporateHotel.related.r3.desc': 'お得意様対応と訪問の作法',
  'corporateHotel.related.r4.title': 'ラグジュアリー営業',
  'corporateHotel.related.r4.desc': '高級車・宝飾・不動産の商談体験を設計',
  'corporateHotel.related.r5.title': '医療・美容クリニック',
  'corporateHotel.related.r5.desc': '自由診療の接遇を院内に定着',
  'corporateHotel.related.r6.title': '自動車・モビリティ',
  'corporateHotel.related.r6.desc': 'ブランド体験の接遇を高める',
  'corporateHotel.related.r7.title': 'ハイヤー・送迎',
  'corporateHotel.related.r7.desc': '乗降の所作と車内の気配りを磨く',
};

export default corporateHotel;
